// extracted by mini-css-extract-plugin
module.exports = {"Button":"📚4-7-0iMm7u","selected":"📚4-7-012z0J"};